import type {
  BadgeColor,
  BadgeVariant,
} from 'Components/_theme/Badge/Badge.types'

import type { TranslationKey } from 'Portal/src/translations'

export const supportedReturnCasePortalStatuses = {
  'awaiting-processing': 'awaiting-processing',
  'blocked-mdm-lock': 'blocked-mdm-lock',
  'blocked-user-lock': 'blocked-user-lock',
  'blocked-user-mdm-lock': 'blocked-user-mdm-lock',
  cancelled: 'cancelled',
  completed: 'completed',
  'in-customs': 'in-customs',
  'in-progress': 'in-progress',
  open: 'open',
  processing: 'processing',
  'resolved-locked': 'resolved-locked',
  'resolved-unreturned': 'resolved-unreturned',
  sold: 'sold',
  upcoming: 'upcoming',
} as const

export type SupportedReturnCasePortalStatuses =
  (typeof supportedReturnCasePortalStatuses)[keyof typeof supportedReturnCasePortalStatuses]

export const RETURN_PORTAL_STATUS_TRANSLATION_IDS: {
  [key in SupportedReturnCasePortalStatuses]: TranslationKey
} = {
  'awaiting-processing': 'rc_portalStatus_AwaitingProcessing',
  'blocked-mdm-lock': 'rc_portalStatus_BlockedMDMLock',
  'blocked-user-lock': 'rc_portalStatus_BlockedUserLock',
  'blocked-user-mdm-lock': 'rc_portalStatus_BlockedUserMDMLock',
  cancelled: 'rc_portalStatus_Cancelled',
  completed: 'rc_portalStatus_Completed',
  'in-customs': 'rc_portalStatus_InCustoms',
  'in-progress': 'rc_portalStatus_InProgress',
  open: 'rc_portalStatus_Open',
  processing: 'rc_portalStatus_Processing',
  'resolved-locked': 'rc_portalStatus_ResolvedLocked',
  'resolved-unreturned': 'rc_portalStatus_ResolvedUnreturned',
  sold: 'rc_portalStatus_Sold',
  upcoming: 'rc_portalStatus_Upcoming',
}

export const RETURN_PORTAL_STATUS_BADGE_COLOR_MAP: {
  [key in SupportedReturnCasePortalStatuses]: BadgeColor
} = {
  'awaiting-processing': 'blue',
  'blocked-mdm-lock': 'red',
  'blocked-user-lock': 'red',
  'blocked-user-mdm-lock': 'red',
  cancelled: 'orange',
  completed: 'green',
  'in-customs': 'blue',
  'in-progress': 'blue',
  open: 'light',
  processing: 'blue',
  'resolved-locked': 'green',
  'resolved-unreturned': 'green',
  sold: 'green',
  upcoming: 'light',
}

export const RETURN_PORTAL_STATUS_BADGE_VARIANT_MAP: {
  [key in SupportedReturnCasePortalStatuses]: BadgeVariant
} = {
  'awaiting-processing': 'secondary',
  'blocked-mdm-lock': 'primary',
  'blocked-user-lock': 'primary',
  'blocked-user-mdm-lock': 'primary',
  cancelled: 'secondary',
  completed: 'secondary',
  'in-customs': 'secondary',
  'in-progress': 'secondary',
  open: 'primary',
  processing: 'secondary',
  'resolved-locked': 'secondary',
  'resolved-unreturned': 'secondary',
  sold: 'secondary',
  upcoming: 'primary',
}
